import { useEffect } from 'react';

// Loading states that are still resolving during the portal's first load. While any
// are held, the first-load screen keeps covering the page so late pieces (route
// chunks, auth checks, disclosures) don't pop in after the initial paint.
const holds = new Set();
const listeners = new Set();
let firstLoadComplete = false;

const notify = () => listeners.forEach((listener) => listener());

export const subscribeToFirstLoadHolds = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getFirstLoadHoldCount = () => holds.size;

export const isFirstLoadComplete = () => firstLoadComplete;

export const completeFirstLoad = () => {
  if (firstLoadComplete) return;
  firstLoadComplete = true;
  holds.clear();
  notify();
};

const useFirstLoadHold = (active = true) => {
  useEffect(() => {
    if (!active || firstLoadComplete) return undefined;

    const hold = {};
    holds.add(hold);
    notify();

    return () => {
      if (holds.delete(hold)) notify();
    };
  }, [active]);
};

export default useFirstLoadHold;
